module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s a lot to know about the great state of Texas. It’s too much for one person to know about or write about. If it were possible to write all of the interesting stories of Texas legends that "), _c('i', [_vm._v("should")]), _vm._v(" have been written, I’d have to use a Ford F-350 pickup to haul the book around. It’d be so big that getting it into a Barnes & Noble bookstore would be a piece of work. Knowing this bit of reality, I selected a sampling of Texas stories to include in this book and relied on a number of friendly Texas folks to help me check out the numerous facts and fancies.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-901b70ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preface.vue
// module id = 72
// module chunks = 0